const classNames = (className: string, classNameObj: any) => {
    const classNameArray = [];
    if(typeof className === 'string') {
        classNameArray.push(className);
    }
    if(typeof classNameObj === 'object') {
        for(let key in classNameObj) {
            if(classNameObj[key] && !classNameArray.includes(key)) {
                classNameArray.push(key)
            }
        }
    }
    return classNameArray.join(' ');
}

export default classNames;